<template lang="pug">
  v-dialog(v-model='Modelo.registerDialog' fullscreen=true)
    template(v-slot:activator='{ on }')
      v-btn(rounded color='primary' v-on='on' @click='cleanSelectedKey(); Modelo.paso_de_formulario = 1')
        v-icon fas fa-plus fa-2x
    v-card
      v-toolbar(dark color='primary')
        v-btn(icon dark @click='Modelo.registerDialog=false')
          v-icon fas fa-times
        v-subheader Módulo de ventas
        v-spacer
        v-layout.justify-end(v-if='!Datos.isClose || !Datos.isAnnulled')
          v-flex.xs4.pa-1
      
      v-stepper(v-model='Modelo.paso_de_formulario', vertical)
        
        v-stepper-step(:complete='Modelo.paso_de_formulario > 1' step='1' @click='Modelo.paso_de_formulario = 1') Generales
        v-stepper-content(step='1')
          Seccion_almacen( :modelo = 'modelo' )
          v-btn( text @click=' Modelo.paso_de_formulario -- ' ) Atrás
          v-btn(color='primary' @click='Modelo.paso_de_formulario ++' ) Siguiente
             
        v-stepper-step(:complete='Modelo.paso_de_formulario > 2' step='2' @click='Modelo.paso_de_formulario = 2') {{(modelo==='Outputs') ? "Proveedor" : "Cliente"}}     
        v-stepper-content(step='2')
          Seccion_cliente( v-if='modelo==="Outputs"' :modelo = 'modelo' )
          Seccion_proveedor( v-if='modelo!=="Outputs"' :modelo = 'modelo' )
          v-btn( text @click=' Modelo.paso_de_formulario -- ' ) Atrás
          v-btn(color='primary' @click='Modelo.paso_de_formulario ++') Siguiente
          
        v-stepper-step(:complete='Modelo.paso_de_formulario > 3' step='3' @click='Modelo.paso_de_formulario = 3') Productos
        v-stepper-content(step='3')
          v-layout.mb-5( wrap )
            v-flex(xs12 md10)
              Seccion_productos( :modelo = 'modelo' )
            v-flex(xs12 md2)
              Seccion_resumen( :modelo = 'modelo' )
          v-btn( text @click=' Modelo.paso_de_formulario -- ' ) Atrás
          v-btn(color='primary' @click='Modelo.paso_de_formulario ++' ) Siguiente
                
        v-stepper-step(step='4' @click='Modelo.paso_de_formulario = 4') Confirmar
        v-stepper-content(step='4')
          v-col
            v-select( v-model ='Modelo.trabajador_asignado' :items='Trabajador_registro' item-text='nombre' item-value='nombre' label='Añadir trabajador asignado'  )
          v-row
            v-btn( text @click='Modelo.paso_de_formulario--') Atrás
            v-btn( color='primary' @click='add()' ) Guardar

</template>
<script>
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex'
import { getPeriod } from '@/Helper.js'
export default {
  data: ()=>({
  }),
  methods:{
    add(){ this.$store.dispatch(`${this.modelo}/add`) },
    annul(){ this.$store.dispatch(`${this.modelo}/annul`) },
    cleanSelectedKey(){ this.$store.dispatch(`${this.modelo}/clearForm`) },
  },
  props: {
    modelo: String
  },
  computed:{
    Modelo() { return this.$store.state[this.modelo] },
    Datos() { return this.$store.state[this.modelo].data },
    ...mapGetters({
        Trabajador_registro: 'Trabajadores/registro',
      }),
  },
  components: {
    Seccion_referencias: () => import('@/components/componentes/Seccion_referencias'),
    Seccion_productos: () => import('@/components/componentes/Seccion_productos'),
    Seccion_resumen: () => import('@/components/componentes/Seccion_resumen'),
    Seccion_cliente: () => import('@/components/componentes/Seccion_cliente'),
    Seccion_proveedor: () => import('@/components/componentes/Seccion_proveedor'),
    Seccion_almacen: () => import('@/components/componentes/Seccion_almacen'),
    Seccion_datos_de_envio: () => import('@/components/componentes/Seccion_datos_de_envio')
  }
}
</script>